document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.getElementById('das-tuning-cartTrigger');

  if (!trigger) return;

  trigger.addEventListener('click', (e) => {
    e.preventDefault();

    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }

    // Fallback: go to cart page if drawer does not exist
    window.location.href = '/cart';
  });
});
